import React from "react"
import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import Divider from "@material-ui/core/Divider"
import { makeStyles } from "@material-ui/core/styles"
import { useTranslation } from "react-i18next"
import PartyDetailsSheet from "../PartyDetails/PartyDetailsSheet"

const useStyles = makeStyles(() => ({
    dialogContent: {
        marginBottom: "20px",
        minWidth: "520px"
    },
    driverBlock: {
        marginBottom: "24px"
    }
}))

const AdditionalDriversListDialog = (props) => {
    const classes = useStyles()
    const { t } = useTranslation()
    const drivers = Array.isArray(props.drivers) ? props.drivers : []

    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            aria-labelledby="additional-drivers-dialog"
            keepMounted={false}
            maxWidth="sm"
        >
            <DialogTitle
                className={["blueText", "subtitleSize"].join(" ")}
                id="additional-drivers-dialog"
            >
                {t("additional_drivers")}
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
                {drivers.map((driver, index) => (
                    <div key={driver.id || index} className={classes.driverBlock}>
                        <div className={["blueText", "subtitleSize"].join(" ")}>
                            {t("driver_number") + " " + (index + 1)}
                        </div>
                        <PartyDetailsSheet party={driver} />
                        {index < drivers.length - 1 ? <Divider /> : null}
                    </div>
                ))}
            </DialogContent>
        </Dialog>
    )
}

export default AdditionalDriversListDialog
